import React from "react";
import { FormattedMessage } from "react-intl";
import { CircularProgress, Dialog, FlatButton, TextField } from "material-ui";
import Clear from "material-ui/svg-icons/content/clear";
import Button from "../EmailAddressBook/Button";
import { checkJapanese, getToken } from "../../lib";
import config from "../../config/config";
import AddressBookDialog from "./AddressBookDialog";
import moment from "moment";
import AddEmailAddress from "../EmailAddressBook/AddEmailAddress";
import Close from "material-ui/svg-icons/navigation/close";
import NotificationSystem from "react-notification-system";

let labelStyle = {
  color: "#657285",
  fontSize: "14px",
  marginTop: "8px",
};

let textFieldStyle = {
  backgroundColor: "#fff",
  minHeight: "38px",
  margin: "8px 0",
};

let inputStyle = {
  border: "1px solid #657285ab",
  minHeight: "38px",
  padding: "0 8px",
  fontSize: "13px",
  color: "#657285",
};

const textareaStyle = {
  color: "#657285",
};

const title = "【LiteFreshVoice】WEB会議ご招待のお知らせ";

function EmailAddedDialog({ data, onClose, handleRoleSelect }) {
  return (
    <Dialog
      modal={false}
      open={true}
      onRequestClose={onClose}
      contentStyle={{ maxWidth: '650px', width: '96%' }}
    >
      <div className="flex items-center flex-column email-added-dialog mt3">
        <Close onClick={onClose} className="close-icon" />
        <FormattedMessage id="emailAddressBook.emailAdded" />
        <div className="flex user-details mt2">
          <ul>
            <li><FormattedMessage id="emailAddressBook.name" /></li>
            <li><FormattedMessage id="emailAddressBook.email" /></li>
            <li><FormattedMessage id="emailAddressBook.role" /></li>
          </ul>
          <ul style={{ listStyleType: 'none', padding: "0 0 0 5px" }}>
            <li><span className="divider">:</span>{data.name}</li>
            <li><span className="divider">:</span>{data.email_address}</li>
            <li>
              <span className="divider">:</span>
                {data.role === 'host' ? <FormattedMessage id="emailAddressBook.host" /> : data.role === 'participant' ? <FormattedMessage id="emailAddressBook.participant" />: 
              <FormattedMessage id="emailAddressBook.hostAndParticipant" />
              }
          </li>
          </ul>
        </div>
        <div className="tc mt3"><FormattedMessage id="emailAddressBook.likeToSendInvitation" /></div>
        <div className="mt2">
          <FlatButton 
            labelStyle={{ color: "#60d1bd" }} 
            label={<FormattedMessage id="emailAddressBook.host" />}
            onClick={() => handleRoleSelect('host')}
          ></FlatButton>
          <FlatButton 
            labelStyle={{ color: "#60d1bd" }} 
            label={<FormattedMessage id="emailAddressBook.participant" />}
            onClick={() => handleRoleSelect('participant')}
          ></FlatButton>
        </div>
      </div>
    </Dialog>
  )
}

const DialogTitle = (props) => {
  return (
    <div>
      <div
        style={{
          backgroundColor: "#657285",
          padding: "12px 16px",
          color: "#fff",
          minHeight: "60px",
        }}
        className="d-flex align-center justify-between"
      >
        <span style={{ fontSize: "15px" }}>{props.heading}</span>
        <div className="flex-center">
          <Button
            label={
              <FormattedMessage id="loggedInNavigation.emailAddressBook" />
            }
            help={false}
            noSpacing={true}
            handleButtonClick={props.handleButtonClick}
            className="desktop-address-book-button"
          />
          <Button
            label={
              <FormattedMessage id="emailAddressBook.addNew" />
            }
            help={false}
            noSpacing={true}
            handleButtonClick={props.handleAddEmailAddress}
            className="desktop-address-book-button"
          />
          <Clear
            onClick={props.handleClose}
            style={{
              fill: "#fff",
              cursor: "pointer",
              width: "30px",
              height: "30px",
            }}
          />
        </div>
      </div>
    </div>
  );
};

class SendEmailDialog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      to: "",
      title: "",
      content: "",
      openAddressBook: false,
      selectedAddresses: [],
      isInProgress: false,
      showContent: false,
      role: "",
      openEmailModal: false,
      openEmailAddedDialog: false,
      selectedEmailAddress: null
    };
    this.contentRef = null;
    this.to = null;
  }

  componentDidMount() {
    if(this.props.resend && this.props.invitation) {
      this.setState({
        role: this.props.invitation.role,
        title: this.props.invitation.title,
        to: this.props.invitation.to,
        content: this.getContent(this.props.invitation.role),
        selectedAddresses: this.props.invitation.selectedAddresses
      })
    } else {
      this.setState({
        title: title,
        content: this.getContent(),
      });
    }

    // to disable the autofocus on mobile view
    setTimeout(() => {
      this.setState({ showContent: true });
    }, 50);
  }

  handleSend = () => {
    if(this.state.selectedAddresses.length === 0) {
      this.setState({ showAddressSelectError: true });
      return;
    }
    if (
      this.contentRef &&
      this.contentRef.input &&
      this.contentRef.input.refs &&
      this.contentRef.input.refs.input &&
      this.contentRef.input.refs.input.innerHTML
    ) {
      this.setState({ isInProgress: true });
      let parser = new DOMParser();
      let content = parser.parseFromString(this.contentRef.input.refs.input.innerHTML, 'text/html');
      if(content) {
        content = content.body.textContent;
      }

      console.log("Content", content);
      const data = {
        to: this.state.to,
        title: this.state.title || title,
        content,
        addresses: this.state.selectedAddresses.map((a) => a.email_address),
        role: this.state.role,
        invited_users: this.state.selectedAddresses.map((a) => a.id).toString(),
        room_name: this.props.sendEmailTo.fvroom_name,
        date: moment().unix(),
        is_webinar: this.props.isWebinar
      };
      fetch(`${config.URI}/api/v1/send_invitation_mail`, {
        method: "POST",
        headers: {
          "Authenticity-Token": getToken(),
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
        .then((r) => r.json())
        .then((res) => {
          this.setState({ isInProgress: false });
          console.log("Result:", res);
          this.props.onSend(
            checkJapanese() ? "招待メールが正常に送信されました。" : "Email invitation has been successfully sent.",
            "success"
          );
        })
        .catch((e) => {
          this.setState({ isInProgress: false });
          this.props.onSend(
            checkJapanese () ? "招待メール送信中にサーバでエラーが発生しました。しばらくしてからもう一度お試しください。" : "Server error occurred while sending the invitation, please try again later.",
            "error"
          );
          console.log("Err: ", e);
        });
    }
  };

  handleAddressSelect = (addresses, role) => {
    this.setState({ openAddressBook: false, selectedAddresses: addresses, role });
    if (addresses.length > 0) {
      // let address = addresses[0];
      this.setState({
        content: this.getContent(role),
        to: this.getTo(addresses),
        showAddressSelectError: false
      });
    }
  };

  getRoomURL = (type) => {
    return type === "host" ? this.props.hostURL : this.props.guestURL;
  };

  getTo = (addresses) => {
    let to = "";
    addresses.map((a, i) => {
      to += `${a.name} (${a.email_address})${
        i + 1 === addresses.length ? "" : ", "
      }`;
      return a;
    });
    return to;
  };

  getNames = () => {};

  getContent = (role = null) => {
    return `※このメールは送信専用のため、ご返信いただけません。\n\n──────────────────────\nWEB会議ご招待のお知らせ\n──────────────────────\n\nLiteFreshVoiceをご利用いただきありがとうございます。\n${
      this.props.user.name
    }さんより、WEB会議の招待が届いています。\n\n■会議名\n${
      this.props.sendEmailTo.fvroom_name
    }\n\n■役割\n${
      role ? role === 'participant' ? '参加者' : 'ホスト' : "{Role}"
    }\n\n■招待URL\nすぐに参加する場合はこちらのリンクをクリックしてください。\n${
      role
        ? this.getRoomURL(role)
        : "{link according to Roll}"
    }\n\n■推奨ブラウザ\n・Windows：GoogleChrome、Microsoft Edge\n・Mac：GoogleChrome\n・iOS(iPhone・iPad)：Google Chrome\n・Android OS：Google Chrome\n\n------------\nサポートアドレス: freshvoice@anets.co.jp\nCopyright © 2021 Anet Co., Ltd. All rights reserved.\n------------`;
  };

  handleAddEmailAddress = () => {
    this.setState({ openEmailModal: true });
  }

  onEmailAddressAdd = (data) => {
    this.props.onAddEmailAddress();
    this.setState({ openEmailModal: false });
    if(data) {
      this.setState({ openEmailAddedDialog: true, selectedEmailAddress: data });
    }
  }

  handleRoleSelect = (role) => {
    this.setState({ role }, () => this.setState({ openAddressBook: true }));
    this.setState({ openEmailAddedDialog: false, selectedEmailAddress: null });
  }

  showNotification = (message, level) => {
    console.log(message, level)
    const notification = this.refs.notificationSystem;
    notification.addNotification({
      message,
      level,
      position: 'tr',
      autoDismiss: 20
    })
  }

  render() {
    const actions = [
      <FlatButton
        label={<FormattedMessage id="emailAddressBook.cancel" />}
        labelStyle={{ color: "#858585" }}
        onClick={this.props.handleClose}
      />,
      <FlatButton
        backgroundColor="#60d1bd"
        hoverColor="#60d1bd"
        label={
          this.state.isInProgress ? (
            ""
          ) : (
            <FormattedMessage id="emailAddressBook.send" />
          )
        }
        labelStyle={{ color: "#fff" }}
        onClick={this.handleSend}
      >
        {this.state.isInProgress ? (
          <CircularProgress
            style={{ marginTop: "5px" }}
            color="#fff"
            size={25}
          />
        ) : (
          ""
        )}
      </FlatButton>,
    ];

    return (
      <div>
        <NotificationSystem ref="notificationSystem" />
        <Dialog
        modal={false}
        title={
          <DialogTitle
            heading={
              <FormattedMessage id="emailAddressBook.sendInvitationEmail" />
            }
            handleClose={this.props.handleClose}
            handleButtonClick={() => this.setState({ openAddressBook: true })}
            handleAddEmailAddress={this.handleAddEmailAddress}
          />
        }
        open={this.props.open}
        onRequestClose={this.props.handleClose}
        contentClassName="popup-modal-content"
        contentStyle={{ maxWidth: "700px", width: "96%" }}
        bodyStyle={{ padding: 0 }}
        autoScrollBodyContent={true}
        actions={actions}
        actionsContainerStyle={{
          display: "flex",
          justifyContent: "space-around",
          backgroundColor: "rgb(241, 241, 241)",
          padding: "12px 28px 15px",
        }}
        className="popup-modal"
        bodyClassName="popup-modal-body"
        
      >
        {this.state.openAddressBook && (
          <AddressBookDialog
            groups={this.props.groups}
            addressBook={this.props.addressBook}
            open={this.state.openAddressBook}
            handleClose={() => {
              this.setState({ openAddressBook: false });
            }}
            onDone={this.handleAddressSelect}
            role={this.state.role}
            selectedAddresses={this.state.selectedAddresses}
          />
        )}
        {this.state.openEmailModal && <AddEmailAddress
          open={this.state.openEmailModal}
          isEdit={false}
          groups={this.props.groups}
          emailAddressBook={this.props.addressBook}
          onSuccess={this.onEmailAddressAdd}
          handleClose={() => this.setState({ openEmailModal: false })}
          showNotification={this.showNotification}
        />}
        {this.state.openEmailAddedDialog && this.state.selectedEmailAddress && (
          <EmailAddedDialog 
            data={this.state.selectedEmailAddress}
            onClose={() => this.setState({ openEmailAddedDialog: false, selectedEmailAddress: null })}
            handleRoleSelect={this.handleRoleSelect}
          />
        )}
        <div
          style={{
            backgroundColor: "rgb(241, 241, 241)",
            padding: "20px 30px",
          }}
        >
          <Button
            label={
              <FormattedMessage id="loggedInNavigation.emailAddressBook" />
            }
            help={false}
            noSpacing={true}
            handleButtonClick={() => this.setState({ openAddressBook: true })}
            className="mobile-address-book-button"
          />
          <Button
            label={
              <FormattedMessage id="emailAddressBook.addNew" />
            }
            help={false}
            noSpacing={true}
            handleButtonClick={this.handleAddEmailAddress}
            className="mobile-address-book-button add-new"
          />
          <div style={{ display: "flex", flexDirection: "column" }}>
            <label style={labelStyle}>
              <FormattedMessage id="emailAddressBook.to" />
            </label>
            <TextField
              fullWidth={true}
              underlineShow={false}
              style={textFieldStyle}
              inputStyle={inputStyle}
              name="to"
              value={this.state.to}
              ref={ref => this.to = ref}
              autoComplete="off"
              textareaStyle={textareaStyle}
              multiLine={true}
              onFocus={() => {
                if(this.to && this.to.input && this.to.input.refs && this.to.input.refs.input) {
                  this.to.input.refs.input.blur()
                }
                this.setState({ openAddressBook: true })
              }}
            />
            {this.state.showAddressSelectError && <label className="width-auto" style={{ fontSize: '14px', color: 'red', marginBottom: '6px' }}><FormattedMessage id="emailAddressBook.selectEmailAddress" /></label>}
          </div>

          <div style={{ display: "flex", flexDirection: "column" }}>
            <label style={labelStyle}>
              <FormattedMessage id="emailAddressBook.title" />
            </label>
            <TextField
              fullWidth={true}
              underlineShow={false}
              style={textFieldStyle}
              name="title"
              inputStyle={{ ...inputStyle }}
              value={this.state.title}
              textareaStyle={textareaStyle}
              onChange={(e) => {
                this.setState({ title: e.target.value });
              }}
              autoComplete="off"
              multiLine={true}
            />
          </div>

          {this.state.showContent && <div style={{ display: "flex", flexDirection: "column" }}>
            <label style={labelStyle}>
              <FormattedMessage id="emailAddressBook.content" />
            </label>
            <TextField
              fullWidth={true}
              underlineShow={false}
              name="content"
              multiLine={true}
              style={{
                ...textFieldStyle,
                height: "unset",
                maxHeight: "300px",
                border: "1px solid #657285ab",
              }}
              inputStyle={{
                ...inputStyle,
                height: "unset",
                maxHeight: "300px",
                border: "none",
              }}
              textareaStyle={{ maxHeight: "280px", color: "#657285" }}
              value={this.state.content}
              rows={12}
              ref={(ref) => {
                this.contentRef = ref;
                // if(this.contentRef && this.contentRef.input && this.contentRef.input.refs && this.contentRef.input.refs.input && this.contentRef.input.refs.input.blur) {
                //   this.contentRef.input.refs.input.blur();
                //   setTimeout(() => {
                //     console.log(this.contentRef.input.refs.input.blur());
                //   }, 1000)
                //   console.log("Blur");
                // }
              }}
              autoFocus={false}
              onChange={(e) => {
                this.setState({ content: e.target.value });
              }}
              autoComplete="off"
            />
          </div>}
        </div>
      </Dialog>
    </div>
    );
  }
}

export default SendEmailDialog;



// WEBPACK FOOTER //
// src/components/Seminars/SendEmailDialog.js